<div class="container">
  <span *ngFor="let tab of tabs; let i = index;" class="tab" [class.selected]="i === selectedIndex" (click)="change.emit(i)">
    {{tab}}
  </span>
</div>
<div class="bottom"></div>
